/* WatchDrop — interacciones (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animaciones de entrada al hacer scroll (un solo observer compartido) */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.wd-reveal:not(.wd-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('wd-visible'); });
      return;
    }
    if (!window.__wdObserver) {
      window.__wdObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wd-visible');
            window.__wdObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__wdObserver.observe(el); });
  }

  /* Reloj digital en vivo (hora de Lima) */
  function initClocks() {
    var clocks = document.querySelectorAll('[data-wd-clock]');
    if (!clocks.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var parts;
      try {
        var fmt = new Intl.DateTimeFormat('es-PE', { timeZone: 'America/Lima', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
        parts = fmt.formatToParts(now).reduce(function (acc, p) { acc[p.type] = p.value; return acc; }, {});
      } catch (e) {
        parts = { hour: pad(now.getHours()), minute: pad(now.getMinutes()), second: pad(now.getSeconds()) };
      }
      clocks.forEach(function (c) {
        var hm = c.querySelector('.wd-clock__hm');
        var s = c.querySelector('.wd-clock__s');
        if (hm) hm.textContent = parts.hour + ':' + parts.minute;
        if (s) s.textContent = parts.second;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Parallax suave de los relojes flotantes del hero */
  function initParallax() {
    var stages = document.querySelectorAll('[data-wd-parallax]');
    if (!stages.length || reduceMotion) return;
    stages.forEach(function (stage) {
      var floats = stage.querySelectorAll('.wd-hero__float');
      var intensity = parseFloat(stage.getAttribute('data-wd-parallax')) || 0;
      if (!intensity) return;
      stage.closest('section').addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        floats.forEach(function (f, i) {
          var depth = (i + 1) * intensity;
          var base = f.getAttribute('data-rot') || '0';
          f.style.transform = 'translate(' + (x * depth) + 'px,' + (y * depth) + 'px) rotate(' + base + 'deg)';
        });
      });
    });
  }

  /* Cifras que cuentan hacia arriba */
  function initCounters() {
    var els = document.querySelectorAll('[data-wd-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-wd-count')) || 0;
      var suffix = el.getAttribute('data-wd-suffix') || '';
      if (reduceMotion) { el.textContent = target + suffix; return; }
      var start = null, dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Página de producto: galería, zoom, variantes, barra fija móvil */
  function initProduct() {
    var pdp = document.querySelector('[data-wd-pdp]');
    if (!pdp) return;

    var main = pdp.querySelector('.wd-pdp__main');
    var mainImg = main && main.querySelector('img');
    var thumbs = pdp.querySelectorAll('.wd-pdp__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg) {
          mainImg.style.opacity = 0;
          setTimeout(function () {
            mainImg.src = t.getAttribute('data-src');
            mainImg.srcset = '';
            mainImg.alt = t.getAttribute('data-alt') || '';
            mainImg.style.opacity = 1;
          }, 180);
        }
      });
    });

    if (main && window.matchMedia('(hover: hover)').matches) {
      main.addEventListener('mousemove', function (e) {
        var r = main.getBoundingClientRect();
        main.style.setProperty('--wd-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        main.style.setProperty('--wd-zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
    }

    /* Variantes (solo si el producto tiene opciones) */
    var dataEl = pdp.querySelector('[data-wd-variants]');
    var selects = pdp.querySelectorAll('[data-wd-option]');
    var idInput = pdp.querySelector('input[name="id"]');
    var priceNow = pdp.querySelectorAll('[data-wd-price]');
    var priceOld = pdp.querySelector('[data-wd-price-old]');
    var buttons = pdp.querySelectorAll('[data-wd-add]');
    var stock = pdp.querySelector('.wd-pdp__stock');
    var stickyPrice = document.querySelector('.wd-sticky-buy__price');
    if (dataEl && selects.length) {
      var variants = JSON.parse(dataEl.textContent);
      var moneyFmt = pdp.getAttribute('data-money') || 'S/ {{amount}}';
      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
      }
      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) {
          buttons.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = pdp.getAttribute('data-txt-unavailable'); });
          return;
        }
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = money(v.price); });
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (priceOld) {
          if (v.compare_at_price && v.compare_at_price > v.price) { priceOld.textContent = money(v.compare_at_price); priceOld.hidden = false; }
          else priceOld.hidden = true;
        }
        buttons.forEach(function (b) {
          b.disabled = !v.available;
          b.querySelector('span').textContent = v.available ? pdp.getAttribute('data-txt-add') : pdp.getAttribute('data-txt-soldout');
        });
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          stock.querySelector('span').textContent = v.available ? pdp.getAttribute('data-txt-instock') : pdp.getAttribute('data-txt-outstock');
        }
        if (v.featured_image && mainImg) { mainImg.src = v.featured_image; mainImg.srcset = ''; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    }

    /* Barra de compra fija en móvil */
    var sticky = document.querySelector('.wd-sticky-buy');
    var buyZone = pdp.querySelector('.wd-pdp__buy');
    if (sticky && buyZone && 'IntersectionObserver' in window) {
      document.body.classList.add('wd-has-sticky');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      });
      io.observe(buyZone);
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        var realBtn = pdp.querySelector('.wd-pdp__buy [data-wd-add]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });
    }
  }

  function initAll() {
    initReveal();
    initClocks();
    initParallax();
    initCounters();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Editor de Shopify: re-inicializa al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initClocks(); initParallax(); initCounters(); });
})();
